import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import Providers from './Providers';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';

// Initialize Sentry (disabled for now - set enabled: true to re-enable)
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "https://d078f3b0c86c1e0545c49de61912552a@o4504768998342656.ingest.us.sentry.io/4510760303198208",
  enabled: false,
  integrations: [
    new BrowserTracing(),
  ],
  environment: process.env.NODE_ENV || "development",
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  beforeSend(event) {
    if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_ENABLE_SENTRY !== "true") return null;
    return event;
  },
});

const queryClient = new QueryClient();

// BNB (and other non-Ethereum mainnet) does not support ENS; ethers/web3-react may try
// to resolve ENS names and log this error. Suppress it so the console is not noisy.
const _consoleError = console.error;
console.error = (...args) => {
  const msg = args[0]?.message ?? String(args[0] ?? '');
  if (typeof msg === 'string' && (msg.includes('network does not support ENS') || msg.includes('Could not fetch ENS'))) return;
  _consoleError.apply(console, args);
};

window.Buffer = require('buffer/').Buffer;

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Providers>
        <App />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Providers>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
